import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OwnerOperatorMenuComponent } from './owner-operator-menu.component';
import { RouterModule } from '@angular/router';
import { A11yModule } from '@angular/cdk/a11y';

@NgModule({
  declarations: [OwnerOperatorMenuComponent],
  imports: [
    CommonModule,
    RouterModule,
    A11yModule
  ],
  exports: [
    OwnerOperatorMenuComponent
  ]
})
export class OwnerOperatorMenuModule { }
